export default "__VITE_ASSET__DIuzAVLY__"